export default "__VITE_ASSET__DrBb$1Ts__"